import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import ReactPixel from 'react-facebook-pixel';
import { GetLearner, SyncORnot, NumberRegister, NumberVerify, PolicyAccepted } from "../../redux/actions/AuthAction";
import { Link, useHistory } from "react-router-dom";
import {MyVerticallyCenteredModal} from "../SpeakerProfileModal"
import { useSnackbar } from "react-simple-snackbar";
import { CopyToClipboard } from "react-copy-to-clipboard";
import emptyTeacher from "../../assets/emptyTeacher.jpg";
import whatsApp from "../../assets/Whatsappalert.png"
import sessionNotes from "../../assets/sessionNotes.png";
import ScrollContainer from "react-indiana-drag-scroll";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import {
  dayRemaining,
  formatAMPM,
  getDate,
  UTCtoLocalConverter,
  LocalToutc,
  currentTimeLocal,
  currentTimeUtc,
  formatTimeslotAMPM,
  utcToLocalDateConverter,
  utcToLocal,
} from "../../helpers/TimeDate";
import VideoModal from "./Modal";
import PhoneInput from "react-phone-number-input";
import {
  parsePhoneNumber,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input";
import { ConfirmDemoPayment, WordOfTheDay } from "../../redux/actions/UserAction";
import { ActivateNext, getAllCourse } from "../../redux/actions/PlanAction";
import {
  GetSessionDocs,
  sessionAttendance,
  sessionCancelled,
} from "../../redux/actions/SessionAction";
import { ResumePlan } from "../../redux/actions/PlanAction";
import Loder from "../../components/loder";
import SocialMediaButtons from "../../components/SosialShare";
import razorpayPaymentHelper from "../../helpers/RazorpayPaymentHelper";
import SubscriptionMessageModal from "../../components/MessageModal/SubscriptionMessageModal";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import SubscriptionModal from "../../components/profile/modals/SubscriptionModal";
import { Modal } from "react-bootstrap";
import Countdown from "react-countdown";

import InfoForm from "../../components/AuthModals/InfoForm";
import PaymentSuccess from "../../components/MessageModal/PaymentSuccess";
import FeedbackModal from "../../components/MessageModal/FeedbackModal";
import Swal from "sweetalert2";
import { initGA, initPixel } from "../../helpers/CampaignEvents";

const Dashboard = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [openSnackbar, closeSnackbar] = useSnackbar();

  const User = useSelector((state) => state.UserReducer.user);
  const CurrentPlan = useSelector((state) => state.PlanReducer.currentplan);
  const upcomming = useSelector((state) => state.UserReducer.upcomingSession);
  const docs = useSelector((state) => state.UserReducer.sessionDocs);
  const videoLibraries = useSelector((state) => state.UserReducer.videos);
  const refData = useSelector((state) => state.UserReducer.learnerRefferalData);
  const allSubscriptions = useSelector(
    (state) => state.PlanReducer.planHistory
  );

  const unaccessroute = JSON.parse(localStorage.getItem("ROUTE"));
  const isLogout = JSON.parse(localStorage.getItem("IS_LOGOUT"));
  const payed = JSON.parse(localStorage.getItem("DEMO_SESSION"));
  const booked = JSON.parse(localStorage.getItem("DEMO_BOOKED"));
  const subscribe = JSON.parse(localStorage.getItem("SUBSCRIBED"));
  const user = JSON.parse(localStorage.getItem("USER"));
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  const isAddPage = localStorage.getItem("ADD_PAGE");

  const userRes = JSON.parse(localStorage.getItem("USERRES"));
  const feedbackModalTime = JSON.parse(localStorage.getItem("FEEDBACK_TIME"));

  const [active, setActive] = useState("main");
  const [loder, setLoder] = useState(false);
  const [statusCode, setstatusCode] = useState(0);
  const [otp, setOtp] = useState("");
  const [docLoding, setDocLoding] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [activateNextDisabled, setActivateNextDisabled] = useState(false);
  const [join, setJoin] = useState(false);
  const [wod, setWod] = useState(null);
  const [copied, setCopied] = useState(false);
  const [demoLoder, setDemoLoder] = useState(false);
  const [subModalShow, setsubModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [internationalNumber, setInternationalNumber] = useState("");
  const [disabledNumber, setDisabledNumber] = useState(false);
  const [callingCode, setCallingCode] = useState("");
  const [numberOremail, setNumberOrEmail] = useState("");
  const [errmsg, setErrmsg] = useState("");
  const [successmsg, setSuccessmsg] = useState("");
  const [resendOTP, setResendOTP] = useState(false);
  const [cookies, setCookie] = useCookies(["user"]);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [cancellationId, setCancellationId] = useState("");
  const [feedbackModal, setFeedbackModal] = useState(false);



  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showTopic, setShowTopic] = useState(false);

  const handleTopicClose = () => setShowTopic(false);
  const handleTopicShow = () => setShowTopic(true);

  const [showWeeklog, setShowWeeklog] = useState(false);

  const handleWeeklogClose = () => setShowWeeklog(false);
  const handleWeeklogShow = () => setShowWeeklog(true);

  const [showBacklog, setShowBacklog] = useState(false);

  const handleBacklogClose = () => setShowBacklog(false);
  const handleBacklogShow = () => setShowBacklog(true);


  const [openModal, setOpenModal] = useState(false);
  const showModal = () => setOpenModal(true);
  const closeModal = () => { setOpenModal(false) }

  const [showPolicy, setShowPolicy] = useState(false);

  const handlePolicyClose = () => setShowPolicy(false);
  const handlePolicyShow = () => setShowPolicy(true);

  const [cancellation, setCancellation] = useState(false);

  const handleCancellationClose = () => setCancellation(false);
  const handleCancellation = () => setCancellation(true);


  const paymentSuccessClose = () => setPaymentSuccess(false);
  const imgUrl =
    "https://s3.ap-south-1.amazonaws.com/cdn.clapingo.com/clapingoWeb";

  const upcomingFiltered = allSubscriptions?.filter(
    (sub) => sub.status === "Upcoming"
  );

  const secondConverter = (weekexp) => {
    var now = new Date().getTime();
    var mydate = new Date(weekexp).getTime();
    return mydate - now;
  };

  useEffect(() => {
    initPixel()
    initGA()
  }, [])

  //SetCookie
  useEffect(() => {
    if (User.isDemoPayed == true) {
      setCookie("demo", true, {
        path: "/"
      });
    }
  }, [User]);

  console.log(upcomming);

  useEffect(() => {
    if (internationalNumber) {
      const userPhoneNumber = parsePhoneNumber(internationalNumber);

      if (userPhoneNumber) {
        if (isValidPhoneNumber(userPhoneNumber.number)) {
          const country_calling_code = getCountryCallingCode(
            userPhoneNumber.country
          );

          setCallingCode("+" + country_calling_code);
          setNumberOrEmail(
            internationalNumber.replace("+" + country_calling_code, "")
          );
        }
      }
    }
  }, [internationalNumber]);



  // console.log(allCourses)

  useEffect(() => {
    if (unaccessroute) {
      history.push(unaccessroute);
      localStorage.removeItem("ROUTE");
    }
  }, [unaccessroute]);

  useEffect(() => {
    document.getElementById("root").classList.add("body_color");
    document.querySelector(".header").classList.add("header_color");
    if (User) {
      // if (!User.isLearnerSync) {
      //   dispatch(SyncORnot({ learnerId: User._id }));
      // }
    }

    const onSuccess = (data) => {
      setWod(data.word);
    };
    dispatch(WordOfTheDay(onSuccess));
  }, []);

  useEffect(() => {
    if (!isLogout) {
      localStorage.clear();
      localStorage.setItem("IS_LOGOUT", true);
      localStorage.setItem("REMOVE", true);
      history.push("/");
      localStorage.removeItem("USER");
      window.location.reload();
      localStorage.removeItem("REMOVE");
    }
    if (feedbackModalTime) {
      if (new Date() > new Date(feedbackModalTime.time)) {
        setFeedbackModal(true)
      }
    }
    // handleShow()
  }, []);

  useEffect(() => {
    if (subscribe) {
      dispatch(GetLearner({ phoneNumber: User.phoneNumber }));
      window.location.reload();
      localStorage.removeItem("SUBSCRIBED");
    }
  }, []);

  //Resume
  const Resume = (data) => {
    const datas = {
      learnerId: data?.learner?._id,
      // subscriptionId: data._id,
      timezone: time_zone.timezone,
      // status:"Running"
    };
    const onSuccess = () => {
      window.location.reload();
    };
    const onError = () => {
      openSnackbar("Something went wrong !!");
    };
    dispatch(ResumePlan(datas, onSuccess, onError));
  };

  //Activate next plan
  const Next = (data) => {
    setActivateNextDisabled(true)
    const datas = {
      learnerId: data.learner._id,
      timezone: time_zone.timezone,
      // status:"Paused"
    };
    const onSuccess = () => {
      window.location.reload();
    };
    const onError = (msg) => {
      openSnackbar(msg);
    };
    dispatch(ActivateNext(datas, onSuccess, onError));
  };

  //cancel session
  const cancelSession = (sessionId) => {
    //console.log(sessionId)
    setCancel(sessionId);
    const onSuccess = (msg) => {
      openSnackbar(msg);
      setCancel(false);
      window.location.reload();
    };
    const onErr = (msg) => {
      openSnackbar(msg);
      setCancel(false);
    };
    dispatch(
      sessionCancelled(
        { sessionId: sessionId, timezone: time_zone.timezone },
        onSuccess,
        onErr
      )
    );
  };




  //joining meeting
  const joinMeeting = (data) => {
    setJoin(data._id);
    if (data.isTimeUtc) {
      var joiningDate = utcToLocal(data.sessionDate, data.startTime);
      var leavingDate = utcToLocal(data.sessionDate, data.endTime);
      var currentTime = new Date();
      if (joiningDate > currentTime) {
        setJoin(false);
        openSnackbar("Your session not started yet");
      } else if (leavingDate < currentTime) {
        setJoin(false);
        openSnackbar("Your session time is over");
      } else {

        localStorage.setItem("FEEDBACK_TIME", JSON.stringify({
          sessionNo: data.sessionCount,
          time: leavingDate,
          id: data._id
        }));

        const onSuccess = () => {
          setJoin(false);
          const url = `https://zoom.clapingo.com/?meetingNumber=${data.meetingNo}&passWord=${data.meetingPassword}&userName=${data.learner.name}&leaveurl=${window.location.href}&endTime=${leavingDate}`;
          window.location.replace(url);
        }

        const onError = (msg) => {
          setJoin(false);
          openSnackbar(msg);
        }

        dispatch(
          sessionAttendance({
            sessionID: data._id,
            joiningTime: currentTimeUtc()
          },
            onSuccess,
            onError
          )
        );
      }
    }
  };

  //open doc
  const OpenSessionDoc = (doc, sessionId, type) => {
    if (type === "LinkAvailable") {
      const docUrl = doc.split("=")
      localStorage.setItem("SESSION_DOC", JSON.stringify(docUrl[1]));
      history.push('/document');
    } else {
      setDocLoding(sessionId);
      const data = {
        sessionCount: doc,
      };
      const onSuccess = (data) => {
        setDocLoding(false);
        if (data.statusCode === 404) {
          openSnackbar(data.message);
        } else {
          // console.log(data);
          const url = data.note.noteLink;
          const docUrl = url.split("=")
          localStorage.setItem("SESSION_DOC", JSON.stringify(docUrl[1]));
          history.push('/document')
        }
      };
      const onErr = (msg) => {
        setDocLoding(false);
        openSnackbar(msg);
      };
      dispatch(GetSessionDocs(data, onSuccess, onErr));
    }
  };

  const DemoPayment = (amount) => {
    setDemoLoder(true);
    var data = {
      amount: time_zone.country === "IN" ? 99 : 199,
      payment_capture: 1,
      currency: time_zone.country === "IN" ? "INR" : "USD",
      notes: {
        Name: User.name,
        Number: User.phoneNumber,
        Email: User.email,
        learnerID: User._id,
        amount: amount,
        paymentDetails: "Payment for Demo",
        from: "website",
      },
      txndesc: "Demo Payment",
    };
    const onSuccess = (rzpRes) => {
      console.log(rzpRes)
      var data = {
        transactionId: rzpRes.razorpay_order_id,
        learnerId: User._id
      }
      var demoPayed = () => {
        setDemoLoder(false);
        localStorage.setItem("DEMO_SESSION", true);
        setPaymentSuccess(true)

        if (isAddPage === true || isAddPage === "true") {
          localStorage.removeItem("ADD_PAGE")
          ReactPixel.track("Start trial", { "Adult website": true });
          localStorage.setItem("ADD_PAGE_USER", true);
        }
      }
      var demoFailed = (errmsg) => {
        setDemoLoder(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: errmsg,
        });
      }
      dispatch(ConfirmDemoPayment(data, demoPayed, demoFailed))

    };

    const modalClose = () => {
      setDemoLoder(false);
    };
    razorpayPaymentHelper(data, onSuccess, modalClose);
  };

  const submit = (count) => {
    confirmAlert({
      title: "Locked",
      childrenElement: () => <h3>Please open after session number {count}</h3>,
      cancelLabel: "Cancel",
      confirmLabel: "Subscribe",
      overlayClassName: "overlay-custom-class-name",
    });
  };

  const pronounce = (word) => {
    var msg = new SpeechSynthesisUtterance();
    msg.text = word;
    window.speechSynthesis.speak(msg);
  };


  useEffect(() => {
    if (user) {
      console.log(user);
      console.log(user.name);
      console.log(user.phoneNumber);
      console.log(user.email);

      if ((!user.name || !user.phoneNumber || !user.email) && (User.isPolicyAccepted == true)) {
        setShowInfoModal(true);
        console.log("show form")
      } else {
        console.log("No need to show")
        setShowInfoModal(false);
      }
    }
  }, [user]);

  // countdown timer
  const renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <span>
        {days} Days {hours} hours {minutes} minutes:{seconds} seconds
      </span>
    );

  };

  //Register number
  const RegisterNumber = (e) => {
    e.preventDefault();
    setLoder(true);
    if (isValidPhoneNumber(internationalNumber)) {
      const data = {
        learnerId: User._id,
        contactDetail: numberOremail,
        countryCode: callingCode
        // password: password,
      };
      const onSucess = (data) => {
        // makeToast("success", msg);

        setstatusCode(data.statusCode)
        setSuccessmsg(data.message)
        setErrmsg("");
        setLoder(false);
      };
      const onError = (data) => {
        // setField("password");
        // setLoder(false);

        setErrmsg(data.message);
        setLoder(false)
      };
      dispatch(NumberRegister(data, onSucess, onError));
    } else {
      setErrmsg("Invalid Mobile Number");
      setLoder(false)
    }
  };

  //Verify number
  const VerifyNumber = (e) => {
    e.preventDefault();
    setLoder(true);
    const data = {
      learnerId: User._id,
      otp: otp
      // password: password,
    };
    const onSucess = (data) => {
      // makeToast("success", msg);

      setstatusCode(data.statusCode)
      window.location.reload();
      openSnackbar("Number registered successfully");
      window.location.reload()
      setLoder(false);
      setResendOTP(false);
      updateLocalStorageObject("USER", "isPhoneNumberVerified", true)
      window.location.reload()

    };
    const onError = (data) => {
      // setField("password");
      // setLoder(false);
      setErrmsg(data);
    };
    dispatch(NumberVerify(data, onSucess, onError));
  };

  //RESEND OTP COUNTER
  useEffect(() => {
    if (resendOTP) {
      var timeLeft = 40;
      var elem = document.getElementById("some_div");
      var timerId = setInterval(countdown, 1000);

      function countdown() {
        if (timeLeft === -1) {
          clearTimeout(timerId);
          setResendOTP(false);
        } else {
          elem.innerHTML = `Resend OTP (${timeLeft})`;
          timeLeft--;
        }
      }
    }
  }, [resendOTP]);

  //Accept t&c
  const acceptPolicy = () => {
    if (User.email) {
      const data = {
        email: User.email
      };
      const onSuccess = () => {
        openSnackbar("Policy Accepted");
        updateLocalStorageObject("USER", "isPolicyAccepted", true);
        window.location.reload()
      };

      const onError = (msg) => {
        openSnackbar(msg);
      };
      dispatch(PolicyAccepted(data, onSuccess, onError));
    } else {
      const data = {
        phoneNumber: User.phoneNumber
      };
      const onSuccess = () => {
        openSnackbar("Policy Accepted");
        updateLocalStorageObject("USER", "isPolicyAccepted", true);
        window.location.reload()
      };

      const onError = (msg) => {
        openSnackbar(msg);
      };
      dispatch(PolicyAccepted(data, onSuccess, onError));
    }
  }

  //update local storage
  const updateLocalStorageObject = function (name, key, value) {
    // Get the existing data
    var existing = localStorage.getItem(name);
    // If no existing data, create an array
    // Otherwise, convert the localStorage string to an array
    existing = existing ? JSON.parse(existing) : {};
    // Add new data to localStorage Array
    existing[key] = value;
    // Save back to localStorage
    localStorage.setItem(name, JSON.stringify(existing));

  };


  return (
    <>
      <Modal show={showInfoModal}>
        <InfoForm
          userData={user}
          setProfile={true}
          userToken={JSON.parse(localStorage.getItem("TOKEN"))}
        />
      </Modal>
      <SubscriptionMessageModal show={show} handleClose={handleClose} />

      <PaymentSuccess show={paymentSuccess} handleClose={paymentSuccessClose} />

      <FeedbackModal show={feedbackModal} setShow={setFeedbackModal} id={feedbackModalTime?.id} number={feedbackModalTime?.sessionNo} />
      {/* Main body */}
      <div className="session  mt-md-0">
        <div className="container-fluid ">
          {/* <hr className="line"></hr> */}
          <div className="row mb-4 ml-md-4 mr-md-4">
            <div className="col-md-8 leftCard">
              <div className="card mx-auto">
                <div className="container pl-0 pr-0">
                  <div className="card-body ">
                    {/* 72 hours coupon discount timer */}
                    {userRes?.data?.demoCouponTime > 0 ?
                      <div className="timer text-center pt-1">
                        <h5>Use <span className="font-weight-bold">{userRes?.data?.coupon}</span> to avail {`${userRes?.data?.demoCouponDiscount}%`} discount. Limited time offer</h5>
                        <h6>
                          <Countdown
                            date={
                              Date.now() +
                              secondConverter(
                                userRes.data.demoCouponEndDate
                              )

                            }
                            renderer={renderer}
                          />
                        </h6>
                      </div> : ""}

                    {/* Verify Phonenumber */}
                    {/* {time_zone.timezone == "Asia/Calcutta" && User.isPhoneNumberVerified == false ?
                      <div className="number text-center">
                        <p className="numbertext pt-2">
                          Hey there! In order to recieve session reminders, please provide<br />
                          your phone number <span onClick={() => showModal(true)} style={{ color: "#4DC591", cursor: "pointer" }}>here</span>
                        </p>
                      </div>
                      :
                      ""
                    } */}
                    {active === "main" && (
                      <div>
                        {User ? (
                          <>
                            <>
                              {/* Before booking a trial */}
                              {user.isTrialBooked ||

                                user.isLearnerSubscribed ||
                                booked ? (
                                ""
                              ) : (
                                <div className="Book_a_trial  pt-4">
                                  {payed || user.isDemoPayed ? (
                                    <>
                                      <h2 className="card-title pl-5 pr-5">
                                        Payment done
                                      </h2>
                                      <p className="card-text pl-5 pr-5">

                                        Your Payment for Demo Session is
                                        successful.Now you can Book a demo
                                        session.
                                      </p>
                                      <button
                                        className="mb-4 ml-5 mr-5"

                                        onClick={() =>
                                          history.push("/bookasession")
                                        }
                                      >
                                        Book
                                      </button>
                                    </>
                                  ) : (

                                    <>{cookies.demo === "true" ? "" :
                                      <div>
                                        <h2 className="card-title pl-5 pr-5">
                                          Book a trial
                                        </h2>
                                        <p className="card-text pl-5 pr-5">
                                          Want to know exactly how Clapingo works?
                                          Book your trial now
                                          <br /> for 15 minutes @{" "}
                                          {time_zone.country === "IN"
                                            ? "Rs.99"
                                            : "1.99 $"}
                                        </p>
                                        <button
                                          disabled={demoLoder}
                                          onClick={() => DemoPayment(1)}
                                          className="mb-4 ml-5"
                                        >
                                          {demoLoder ? "Processing.." : "Book"}{" "}
                                        </button>
                                      </div>
                                    }

                                    </>
                                  )}
                                  {cookies.demo === "true" ? "" :
                                    <hr />}

                                </div>
                              )}

                              {/* Before booking a trial end */}
                            </>
                            {CurrentPlan && user.isLearnerSubscribed ? (
                              <div

                                className={`${CurrentPlan.status === "Paused"
                                  ? "paused"
                                  : ""
                                  }`}
                              >
                                {/* AFTER SUBCRIBING */}
                                <div
                                  className={`${CurrentPlan.status === "Paused"
                                    ? "pauseActive"
                                    : ""
                                    }`}

                                >
                                  <div className="timer text-center pt-1">
                                    {/* <span>Week 1:</span>  */}
                                    {CurrentPlan.status === "Paused" ? (
                                      ""
                                    ) : (
                                      <div>
                                        {CurrentPlan.subscriptionType ==

                                          "quick_learner_mode" ? (

                                          <div>
                                            {/* <span>Week details:</span> */}
                                            {/* <span className="ml-1 text-success" style={{ cursor: "pointer" }} onClick={handleWeeklogShow}><i class="far fa-question-circle" ></i></span> */}
                                            <span style={{ color: "grey" }}>
                                              Your sessions will expire in
                                            </span>
                                            <p>
                                              <Countdown
                                                date={
                                                  Date.now() +
                                                  secondConverter(
                                                    CurrentPlan.endDate
                                                  )
                                                }
                                                renderer={renderer}
                                              />
                                            </p>
                                          </div>
                                        ) : (
                                          <div>
                                            <span>Week details:</span>
                                            <span
                                              className="ml-1 text-success"
                                              style={{ cursor: "pointer" }}
                                              onClick={handleWeeklogShow}
                                            >
                                              <i class="far fa-question-circle"></i>
                                            </span>
                                            <span style={{ color: "grey" }}>
                                              Your{" "}
                                              {
                                                CurrentPlan.availableWeeklySession
                                              }{" "}
                                              sessions will expire in
                                            </span>
                                            <p>
                                              <Countdown
                                                date={
                                                  Date.now() +
                                                  secondConverter(
                                                    CurrentPlan.weekEnd
                                                  )
                                                }
                                                renderer={renderer}
                                              />
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                  <div className="subscription d-flex justify-content-between">
                                    <p className="plan_name">

                                      {CurrentPlan?.plan?.courseName}
                                      {CurrentPlan?.status === "Paused" ? (

                                        <p>Paused</p>
                                      ) : (
                                        ""
                                      )}
                                    </p>
                                    <p
                                      className="expire"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => setsubModalShow(true)}
                                    >
                                      View more
                                    </p>
                                  </div>
                                  <div className="dateText">
                                    <span className="spanA">Start Date:</span>{" "}
                                    <span className="spanB">End Date:</span>
                                  </div>
                                  <div className="dateText ">
                                    <span className="spanC">
                                      {CurrentPlan?.isTimeUtc
                                        ? UTCtoLocalConverter(

                                          CurrentPlan?.startDate
                                        )

                                        : getDate(CurrentPlan?.startDate)}
                                    </span>
                                    <span className="spanD">
                                      {CurrentPlan?.isTimeUtc
                                        ? UTCtoLocalConverter(

                                          CurrentPlan?.endDate
                                        )

                                        : getDate(CurrentPlan?.endDate)}
                                    </span>
                                  </div>
                                  <div className="session_No mt-3">
                                    <div className="d-md-flex justify-content-between">
                                      <p className="session_text">
                                        Sessions left:
                                        <span className="inner">
                                          {CurrentPlan?.availableSession}
                                        </span>
                                      </p>
                                      {CurrentPlan?.subscriptionType ==

                                        "quick_learner_mode" ? (

                                        ""
                                      ) : (
                                        <p className="session_text">
                                          Sessions left this week:
                                          <span className="inner">
                                            {
                                              CurrentPlan?.availableWeeklySession
                                            }
                                          </span>
                                        </p>
                                      )}

                                      <p className="session_text">
                                        Sessions cancelled:
                                        <span className="inner">
                                          {CurrentPlan?.canceledSession}
                                        </span>
                                      </p>
                                    </div>
                                    <div className="d-md-flex justify-content-between">
                                      <p className="session_text mr-5">
                                        Total Sessions:
                                        <span className="inner">
                                          {CurrentPlan?.totalSession}
                                        </span>
                                      </p>
                                      {CurrentPlan?.subscriptionType ==
                                        "quick_learner_mode" ? (

                                        ""
                                      ) : (
                                        <p className="session_text mr-5">
                                          Total sessions this week:
                                          <span className="inner">
                                            {CurrentPlan?.totalWeeklySession}
                                          </span>
                                        </p>
                                      )}

                                      {/* backlog style changes based on quick_learner_mode exist or not */}

                                      {CurrentPlan.subscriptionType ==

                                        "quick_learner_mode" ? (

                                        //  Showing backlog only when issubscriptionnew is true
                                        CurrentPlan.isSubscriptionNew ? (
                                          <p className="session_textbl">
                                            Backlog:
                                            <span className="inner">
                                              {CurrentPlan?.backlogSession}
                                            </span>
                                            <span
                                              className="ml-1"
                                              style={{ cursor: "pointer" }}
                                              onClick={handleBacklogShow}
                                            >
                                              <i class="far fa-question-circle"></i>

                                            </span>
                                          </p>
                                        ) : (
                                          ""
                                        )
                                      ) : //  Showing backlog only when issubscriptionnew is true
                                        CurrentPlan.isSubscriptionNew ? (
                                          <p className="session_text">
                                            Backlog:
                                            <span className="inner">
                                              {CurrentPlan?.backlogSession}
                                            </span>
                                            <span
                                              className="ml-1"
                                              style={{ cursor: "pointer" }}
                                              onClick={handleBacklogShow}
                                            >
                                              <i class="far fa-question-circle"></i>
                                            </span>
                                          </p>
                                        ) : (
                                          ""
                                        )}


                                      <p style={{ color: "#ffffff" }}>......</p>
                                    </div>
                                  </div>

                                  {/* Conditional rendering of book a slot or activate next plan */}
                                  {
                                    CurrentPlan?.backlogSession === 0 &&

                                      CurrentPlan?.availableSession === 0 &&
                                      upcomingFiltered.length > 0 ?
                                      (

                                        <div>
                                          <div className="d-flex justify-content-around">
                                            <button
                                              className="mt-3 mb-2 "
                                              id="activatenextid"
                                              onClick={() => Next(CurrentPlan)}
                                              disabled={activateNextDisabled}
                                            >
                                              Activate next plan
                                            </button>
                                            <button
                                              className="mt-3 mb-2 "
                                              id="bookaslotid"
                                              onClick={() =>
                                                history.push(
                                                  "/student/planandprice"
                                                )
                                              }
                                            >
                                              Resubscribe
                                            </button>
                                          </div>
                                          {/* <p className="howitworks">How it works?</p> */}
                                        </div>
                                      ) : CurrentPlan.status === "Paused" ? (
                                        <button
                                          className="mt-3 mb-4 subscribed_button"
                                          id="bookaslotid"
                                          onClick={() =>
                                            history.push("/bookasession")
                                          }
                                          disabled
                                        >
                                          Book a slot
                                        </button>
                                      ) : (
                                        <div>

                                          <div className="d-flex justify-content-around">
                                            <button
                                              className="mt-3 mb-2 "

                                              id="bookaslotid"
                                              onClick={() =>
                                                history.push("/bookasession")
                                              }
                                            >
                                              Book a slot
                                            </button>
                                            <button

                                              className="mt-3 mb-2 "

                                              id="bookaslotid"
                                              onClick={() =>
                                                history.push(
                                                  "/student/planandprice"
                                                )
                                              }
                                            >
                                              Resubscribe
                                            </button>
                                          </div>
                                          {/* <p className="howitworks">How it works?</p> */}
                                        </div>
                                      )}
                                </div>
                                <div

                                  className={` ${CurrentPlan.status === "Paused"
                                    ? "pauseOverride"
                                    : ""
                                    }`}

                                >
                                  {CurrentPlan.status === "Paused" ? (
                                    <div className="text-center">
                                      <hr className="pauseHr" />
                                      <h3>Paused!</h3>
                                      <hr className="pauseHr" />
                                      <p>
                                        Your subscription has been paused.
                                        <br />
                                        It will resume in
                                      </p>
                                      <h3>
                                        <Countdown
                                          date={
                                            Date.now() +
                                            secondConverter(
                                              CurrentPlan.pauseDetails.slice(
                                                -1
                                              )[0].pauseResumeDate
                                            )
                                          }
                                          renderer={renderer}
                                        />
                                      </h3>
                                      <button
                                        className="resumeButtonhome"
                                        onClick={() => Resume(CurrentPlan)}
                                        style={{
                                          fontSize: "20px",
                                          paddingTop: "0px",
                                        }}
                                      >
                                        Resume
                                      </button>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            ) : (
                              <div className="Book_a_trial pl-5 pr-5 pt-4 mb-4">
                                <h2 className="card-title">
                                  Subscription & Plans
                                </h2>
                                <p className="card-text">
                                  Subscribe to Clapingo and Hone your English
                                  Speaking skills over 1 - 1 Video Call.
                                </p>
                                <button
                                  onClick={() =>
                                    history.push("/student/planandprice")
                                  }
                                >
                                  Continue
                                </button>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="m-5">
                            <Loder />
                          </div>
                        )}

                        <div
                          style={{
                            display: upcomming
                              ? upcomming.length <= 0
                                ? "none"
                                : "block"
                              : "",
                          }}
                        >
                          <hr />
                          <div className="upcoming_sessions pl-md-5 pr-md-5 pl-2 pr-2">
                            <div className="d-flex justify-content-between">
                              <p className="card-title">Upcoming Session</p>
                              <button
                                className="buttonleft"
                                onClick={() =>
                                  history.push("/upcoming_session")
                                }
                              >
                                View all
                              </button>
                            </div>

                            <div
                              className="d-flex learner_session"
                              style={{ overflowX: "auto" }}
                            >
                              {upcomming ? (
                                upcomming.slice(0, 4).map((data, i) => (
                                  <div
                                    className={`${data.isCancel ? "wrap" : ""}`}
                                    key={i}
                                  >
                                    <div
                                      className={` learner_upcomming_card ${data.isCancel ? "cancelled" : ""
                                        }`}
                                      key={i}
                                    >
                                      <div className="media mx-auto session_card">
                                        <div className="teacher_img">
                                          {/* <Link to={`/speaker-profiles/${data.teacher._id}`}> */}
                                          <img
                                            src={
                                              data.teacher.image
                                                ? data.teacher.image
                                                : emptyTeacher
                                            }
                                            alt={data.teacher.name}
                                          />
                                          {/* </Link> */}
                                          

                                          <p className="text-center">
                                            {data.teacher.name}
                                          </p>
                                          
                                        </div>
                                        
                                        <div className="media-body">
                                          <h5 className="text-center">
                                            {data.type === "Regular"
                                              ? "Session" +
                                              " " +
                                              data.sessionCount
                                              : "Demo Session"}{" "}
                                          </h5>
                                          <div className="session_content">
                                            <p>
                                              <span>Date:</span>
                                              {utcToLocalDateConverter(data.sessionDate, data.endTime)}
                                            </p>
                                            <p>
                                              <span>Time:</span>
                                              {data.isTimeUtc
                                                ? formatTimeslotAMPM(`${data.startTime}-${data.endTime}`)
                                                : data.startTime +
                                                " - " +
                                                data.endTime}

                                            </p>
                                            {data.cancelBy? <div style={{ fontSize: "10px" }}><i class="fas fa-sync"></i> Re-assigned from <span style={{ color:"orange", fontWeight:"bold"}}>{data.cancelBy.name}</span><br/><span style={{color:"blueviolet"}}>Due to an emergency, tutor won't be able to join this session. You have been re-assigned to a new tutor.</span></div>  :""}
                                            

                                            {window.innerWidth < 992 ? <p style={{ color: "red", fontSize: "10px" }}>Video calls are not supported in mobile web. For best experience use a Laptop or Clapingo App

                                              <a href="https://play.google.com/store/apps/details?id=com.app.clapingo">
                                                <img src={`https://images.weserv.nl/?url=${imgUrl}/gplay.png&w=135&h=40&output=webp`} height="50%" width="50%" alt="mobile.png" />
                                              </a>


                                              <a href="https://apps.apple.com/in/app/clapingo/id1595487516">
                                                <img src={`https://images.weserv.nl/?url=${imgUrl}/apple.png&w=135&h=40&output=webp`} height="50%" width="50%" alt="mobile.png" />
                                              </a>

                                            </p> : ""}


                                            {data.type === "Regular" ? (
                                              <p
                                                className="notes"
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  OpenSessionDoc(
                                                    data.sessionCount,
                                                    data._id
                                                  )
                                                }
                                              >
                                                {docLoding === data._id
                                                  ? "Fetching..."
                                                  : "Session notes"}{" "}
                                                <i className="fas fa-download"></i>
                                              </p>
                                            ) : (
                                              <div
                                                className="notes"
                                                style={{ cursor: "pointer" }}

                                                onClick={() => {
                                                  OpenSessionDoc(
                                                    "url=https://clapngobucket.s3.amazonaws.com/documents/learner/Demo+Session+Document_compressed.pdf",
                                                    data._id,
                                                    "LinkAvailable"
                                                  )

                                                }}
                                              >
                                                {docLoding === data._id
                                                  ? "Fetching..."
                                                  : "Demo notes"}{" "}
                                                <i className="fas fa-download"></i>
                                              </div>
                                            )}
                                          </div>
                                          <div className="session_buttons d-flex flex-row-reverse">
                                            {window.innerWidth < 992 ?
                                              <button
                                                id="joinupcoming"
                                                className="join"
                                                onClick={() => joinMeeting(data)}
                                                disabled={true}
                                              >
                                                {join === data._id ? "Joining.." : "Join"}
                                              </button> :
                                              <button
                                                id="joinupcoming"
                                                className="join"
                                                onClick={() => joinMeeting(data)}
                                                disabled={join}
                                              >
                                                {join === data._id ? "Joining.." : "Join"}
                                              </button>}

                                            {data.type === "Regular" ? (

                                              <button
                                                className="cancel"
                                                // onClick={() =>
                                                //   cancelSession(data._id)
                                                // }
                                                onClick={() => { handleCancellation(); setCancellationId(data._id) }}
                                              >
                                                cancel
                                              </button>
                                            ) : ""}

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className={` ${data.isCancel ? "override" : ""
                                        }`}
                                    >
                                      {data.isCancel ? <h3>Cancelled!</h3> : ""}

                                    </div>

                                  </div>
                                ))
                              ) : (
                                <div
                                  className="m-5 text-center"
                                  style={{ width: "100%" }}
                                >
                                  <Loder />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <hr />

                        {/* AFTER SUBSCRIBING END */}

                        <div className="d-flex justify-content-between pl-5 pr-5">
                          <p className="study">
                            Topics{" "}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={handleTopicShow}
                            >
                              <i class="far fa-question-circle"></i>
                            </span>
                          </p>
                          <button
                            className="mini-button"
                            onClick={() => setActive("First")}
                          >
                            View all
                          </button>
                        </div>

                        <ScrollContainer
                          horizontal={true}
                          className="wrapper mt-4 mb-4 pl-5 pr-5"
                        >
                          {docs.notes ? (
                            docs.notes.slice(0, 4).map((data, i) => (
                              <div
                                className="item mr-2 pointer"
                                key={i}
                                onClick={() => {
                                  docs
                                    ? docs.sessionTaken > data.sessionCount
                                      ?
                                      OpenSessionDoc(
                                        data.noteLink,
                                        0,
                                        "LinkAvailable"
                                      )
                                      // openInNewTab(data.noteLink)
                                      : submit(data.sessionCount)
                                    : console.log("loding");
                                }}
                              >

                                <img
                                  // className=" mr-2"
                                  src={sessionNotes}
                                  alt="icon"
                                />
                                <div className="centered">

                                  Session {data.sessionCount}
                                  {docs ? (
                                    docs.sessionTaken <= data.sessionCount ? (
                                      <i className="fas fa-lock"></i>
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div
                              className="m-5 text-center"
                              style={{ width: "100%" }}
                            >
                              <Loder />
                            </div>
                          )}
                        </ScrollContainer>

                        <hr />
                        <div className="d-flex justify-content-between pl-5 pr-5">
                          <h2 className="video">Video Library</h2>
                          <button
                            className="mini-button"
                            onClick={() => setActive("Second")}
                          >
                            View all
                          </button>
                        </div>
                        <ScrollContainer
                          horizontal={true}
                          className="wrapper mt-4 pl-5 pr-5"
                        >
                          {videoLibraries
                            ? videoLibraries.slice(0, 4).map((data, i) => (
                              <div className="item item  mr-2" key={i}>
                                <VideoModal
                                  videoId={data.videoId}
                                  name={data.name}
                                  img={data.imageUrl}
                                />
                              </div>
                            ))
                            : ""}
                        </ScrollContainer>
                      </div>
                    )}
                    {active === "First" && (
                      <div className="doc_container pl-5 pr-5 pt-4">
                        <button
                          style={{ width: "70px", height: "30px" }}
                          onClick={() => setActive("main")}
                        >
                          Back
                        </button>
                        <p
                          style={{
                            fontSize: "24px",
                            fontWeight: "600",
                            marginTop: "15px",
                          }}
                        >
                          Study Materials
                        </p>
                        <div className="row">
                          {docs.notes
                            ? docs.notes.map((data, i) => (

                              <div
                                className="col-md-4 pointer"
                                key={i}
                                onClick={() => {
                                  docs
                                    ? docs.sessionTaken > data.sessionCount
                                      ?
                                      OpenSessionDoc(
                                        data.noteLink,
                                        0,
                                        "LinkAvailable"
                                      )
                                      //openInNewTab(data.noteLink)
                                      : submit(data.sessionCount)
                                    : console.log("loding");
                                }}
                              >
                                <div className="item mb-3">
                                  <img
                                    // className=" mr-2"
                                    src={sessionNotes}
                                    alt="icon"
                                  />
                                  <div className="centered">
                                    <p>Session {data.sessionCount}</p>
                                    {docs ? (
                                      docs.sessionTaken <=

                                        data.sessionCount ? (
                                        <i className="fas fa-lock"></i>
                                      ) : (
                                        ""
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))
                            : ""}
                        </div>

                        {/* <img
                          className=" mr-2 mb-3"
                          style={{ width: "170px" }}
                          src={RectangleA}
                          alt="icon"
                        /> */}
                      </div>
                    )}
                    {active === "Second" && (
                      <div className="pl-5 pr-5 pt-4">
                        <button
                          style={{ width: "70px", height: "30px" }}
                          onClick={() => setActive("main")}
                        >
                          Back
                        </button>
                        <p
                          style={{
                            fontSize: "24px",
                            fontWeight: "600",
                            marginTop: "15px",
                          }}
                        >
                          Video Gallery
                        </p>

                        <div className="row">
                          {videoLibraries
                            ? videoLibraries.map((data, i) => (
                              <div
                                className="col-md-5 video_library_videos"
                                key={i}
                              >
                                <div className="itemA item  mr-2" key={i}>
                                  <VideoModal
                                    videoId={data.videoId}
                                    name={data.name}
                                    img={data.imageUrl}
                                  />
                                </div>
                              </div>
                            ))
                            : ""}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mx-auto mt-4 mt-md-0">
              <div className="row">
                <div className="col rightCardA">
                  <div className="card mx-auto">
                    <div className="card-body">
                      <h3 className="card-title mb-4 pb-1">Word of the Day</h3>
                      <span
                        className="word mt-5 pt-5"
                        onClick={() => pronounce(wod.word)}
                      >
                        {wod ? wod.word : "Loading.."}
                        {wod ? (
                          <i
                            className="fas fa-volume-up ml-3 text-white"
                            style={{ cursor: "pointer" }}
                          ></i>
                        ) : (
                          ""
                        )}
                      </span>
                      {/* <p className="subtitle">noun</p> */}
                      <p className="card-text">
                        {wod ? wod.meaning.split("Eg")[0] : "Loading.."}
                      </p>
                      <p className="italic">
                        Eg{wod ? wod.meaning.split("Eg")[1] : "Loading.."}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="row">
                <div className="col rightCardC">
                  <div className="cardc mx-auto">

                    <div className="row">
                      <div className="col-md-10">
                        <p className="titlec">
                          Enable <span style={{color:"#25D366"}}>Whatsapp</span> alerts!
                        </p>
                        <p className="subtitlec mt-1">Recieve reminders, updates for your sessions and payments</p>
                      </div>
                      <div className="col-md-2">
                        <div className="">
                          <img src={whatsApp} alt="whatsapp" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div> */}

              <div className="row">
                <div className="col rightCardB">
                  <div className="card mx-auto">
                    <div className="card-body">
                      <h2 className="card-title mb-4 pb-1">Refer & Earn</h2>

                      <span>Your referral code</span>
                      <div className="d-flex">
                        <input
                          type="text"

                          value={refData ? refData.showReferralUi ? refData.refCode : "Hidden" : "Loading.."}
                        />
                        <CopyToClipboard
                          text={refData ? refData.showReferralUi ? refData.refCode : "Hidden" : "Loading.."}
                          onCopy={() => {
                            openSnackbar("Refferal code copied successfully");
                            setCopied(true);
                          }}
                        >
                          <button
                            type="button"
                            id="button-addon2"
                          // disabled={isSubscribed}
                          >
                            copy
                          </button>
                        </CopyToClipboard>
                      </div>

                      {
                        !refData?.showReferralUi ?
                          <p className="text-danger">Please subscribe to unlock Refer & Earn !</p>
                          : ""
                      }
                      <div className="mt-4 mb-4">
                        <SocialMediaButtons refData={refData ? refData.showReferralUi ? refData : null : "Loading.."} />
                      </div>
                    </div>

                  </div>
                </div>
              </div>



            </div>
          </div>

        </div>
      </div>

      {/* MODALS */}

      <SubscriptionModal
        show={subModalShow}
        onHide={() => setsubModalShow(false)}
      />

      {/* Topic Modal */}
      <Modal
        show={showTopic}
        onHide={handleTopicClose}
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="feedback"
      >
        <Modal.Body>
          <p>
            Reffer to the document before a session for topic of the day and
            other resources to improve your English{" "}
          </p>
          <button
            className="session_document_alert"
            onClick={() => handleTopicClose()}
          >
            Dismiss
          </button>
        </Modal.Body>
      </Modal>

      {/* About weekly session Modal */}
      <Modal
        show={showWeeklog}
        onHide={handleWeeklogClose}
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="feedback"
      >
        <Modal.Body>
          <h6>About Weekly Session </h6>

          <ul className="list-group">
            <li className="list-group-item text-dark">

              Your {CurrentPlan?.plan?.classDuration} one-on-one subscription
              covers {CurrentPlan?.plan?.frequency} session per week for{" "}
              {CurrentPlan?.month} month
            </li>

            <li className="list-group-item text-dark">

              It is advised to complete your weekly session on time.
            </li>
          </ul>
          <hr />
          <h6>Week details</h6>

          <ul className="list-group">
            <li className="list-group-item text-dark">

              <div>
                <span>Start Date:</span>
                <span style={{ float: "right" }}>
                  {CurrentPlan?.isTimeUtc
                    ? UTCtoLocalConverter(CurrentPlan.weekStart)
                    : getDate(CurrentPlan?.weekStart)}
                </span>
              </div>
            </li>

            <li className="list-group-item text-dark">

              <div>
                <span>End Date:</span>
                <span style={{ float: "right" }}>
                  {CurrentPlan?.isTimeUtc
                    ? UTCtoLocalConverter(CurrentPlan.weekEnd)
                    : getDate(CurrentPlan?.weekEnd)}
                </span>
              </div>
            </li>
          </ul>

          <button
            className="session_document_alert"
            onClick={() => handleWeeklogClose()}
          >
            Dismiss
          </button>
        </Modal.Body>
      </Modal>

      {/*  Backlog session Modal */}
      <Modal
        show={showBacklog}
        onHide={handleBacklogClose}
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="feedback"
      >
        <Modal.Body>
          <h6>About Backlog Session </h6>
          <ul class="list-group">
            <li class="list-group-item text-dark">
              Backlog Session is a session which gets failed due to some
              technical issue from our side. In a case of failure, that failed
              session is added as a backlog Session
            </li>
            <li class="list-group-item text-dark">
              Backlog Session doesn’t have a week expiry, it can be taken
              anytime before your plan ends.
            </li>
          </ul>
          <hr />
          <button
            className="session_document_alert"
            onClick={() => handleBacklogClose()}
          >
            Dismiss
          </button>
        </Modal.Body>
      </Modal>

      {/* Register number modal */}
      <Modal
        show={openModal}
        onHide={closeModal}
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="feedback"
        onExit={() => window.location.reload()}
      >
        <Modal.Body>
          <h6 className="ml-3">Register your number</h6>
          <form
            className="text-center "
            onSubmit={
              statusCode == 201 ?
                (e) => VerifyNumber(e) :
                statusCode == 201 && resendOTP == true ?
                  (e) => RegisterNumber(e) :
                  (e) => RegisterNumber(e)
              // : statusCode === "showOTP"
              //   ? (e) => verifyOTP(e):""

            }
          >
            <PhoneInput
              placeholder="Enter Mobile number"
              className="input inp mt-3 "
              international
              countryCallingCodeEditable={true}
              defaultCountry={time_zone.country}
              country={time_zone.country}
              value={internationalNumber}
              onChange={setInternationalNumber}
              disabled={disabledNumber}
            />
            {statusCode == 201 ?
              (
                <>
                  <input
                    className="input mt-3 ml-1"
                    placeholder="6-digit OTP"
                    type="number"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    required
                  />
                  {/* <label className="invalid_message"></label> */}
                  <br />



                  <br />
                  {resendOTP ? (
                    <p
                      className="text-danger mr-5"
                      id="some_div"
                      style={{ textAlign: "right" }}
                    ></p>
                  ) : (
                    <p
                      style={{ textAlign: "right", cursor: "pointer" }}
                      onClick={(e) => {
                        setResendOTP(true);
                        RegisterNumber(e);
                      }}
                      className="mr-5"
                    >
                      Resend OTP ?
                    </p>
                  )}
                  {successmsg ? <label className="invalid_message text-success">{successmsg}</label>
                    : <label className="invalid_message ">{errmsg}</label>}

                </>
              )
              : ""}
            <p className="text-danger">{errmsg}</p>
            <button
              type="submit"
              disabled={loder ? true : false}
              className={
                loder ? "continueBTNdisabled ml-md-3" : "continueBTN ml-md-3"
              }
            >
              {loder ? "Loading ..." : "Continue"}
            </button>
          </form>
        </Modal.Body>
      </Modal>
      {/* Policy Modal */}
      <Modal
        show={User.isPolicyAccepted == false ? true : false}
        onHide={handlePolicyClose}
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="feedback"
      >
        <Modal.Body>
          <h6>Terms & Conditions</h6>
          <ul class="list-group">
            <li class="list-group-item text-dark">
              To continue using Clapingo you must accept our <a target="_blank" href="https://clapngobucket.s3.amazonaws.com/documents/misc/policy_and_terms.pdf" className="text-primary">Terms & Conditions</a>
            </li>

          </ul>

          <button
            className="session_document_alert"
            onClick={() => acceptPolicy()}
          >
            Accept
          </button>
        </Modal.Body>
      </Modal>

      {/* Session Cancellation Confirmation Modal */}
      <Modal
        show={cancellation}
        onHide={handleCancellationClose}
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="feedback"
      >
        <Modal.Body>
          <div className="text-center">
            <h3>Confirm Session Cancellation</h3>
            <p>Are you sure you want to cancel your session?</p>
          </div>
          <div className="d-flex justify-content-center">
            <button
              style={{ margin: "0px", width: "150px", height: "35px" }}
              onClick={() => cancelSession(cancellationId)}
            >
              {cancel === cancellationId
                ? "canceling.."
                : "Yes"}
            </button>
            <button
              style={{ margin: "0px", width: "150px", height: "35px", marginLeft: "20px" }}
              onClick={() => handleCancellationClose()}
            >
              No
            </button>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default Dashboard;
